import { AddressBookMapper } from '../AddressBookMapper.js';

class WarehouseAddressesMapper {
  static createWarehouseAddressFromResponse(response) {
    return response.map(address => ({
      ...AddressBookMapper.createAddressBookFromResponse(address),
      isDefault: address.default_selection
    }));
  }
}

export { WarehouseAddressesMapper };
//# sourceMappingURL=WarehouseAddressesMapper.js.map
